var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0AF062DF-DBAA-4B36-BB8F-81FDF52C2746") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "C_In-a-Call-Settings-V5",
    transform: "translate(-983.000000, -41.000000)",
    fill: "#354354",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "modal",
    transform: "translate(413.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-close",
    transform: "translate(570.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5300101,16.353922 C18.9301797,16.7403337 19.0906683,17.3125511 18.9497921,17.8506421 C18.808916,18.388733 18.3885986,18.808958 17.8503893,18.9498032 C17.31218,19.0906484 16.7398368,18.930195 16.3533401,18.5301135 L12,14.1761915 L7.6466599,18.5301135 C7.04264337,19.1133639 6.08252885,19.1050226 5.48874158,18.5113659 C4.8949543,17.9177092 4.88661117,16.9578057 5.46998985,16.353922 L9.82332995,12 L5.46998985,7.646078 C5.06982032,7.25966632 4.90933168,6.68744889 5.05020786,6.14935795 C5.19108404,5.61126701 5.61140143,5.19104203 6.1496107,5.05019682 C6.68781998,4.90935162 7.26016324,5.06980497 7.6466599,5.46988652 L12,9.82380852 L16.3533401,5.46988652 C16.7398368,5.06980497 17.31218,4.90935162 17.8503893,5.05019682 C18.3885986,5.19104203 18.808916,5.61126701 18.9497921,6.14935795 C19.0906683,6.68744889 18.9301797,7.25966632 18.5300101,7.646078 L14.17667,12 L18.5300101,16.353922 Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.e7d00932d783014242b13378017b78dc.svg";
export { ForwardRef as ReactComponent };